import React, { useEffect, useRef, useState } from "react";

const groups = ["ABCDEFGHJKLMNPQRSTUVWXYZ", "abcdefghijkmnopqrstuvwxyz", "23456789", "!@#$%&*+-_=?"];
export function suggestPassword() {
  const alphabet = groups.join("");
  const randomIndex = size => {
    const limit = 256 - (256 % size);
    const bytes = new Uint8Array(1);
    do { window.crypto.getRandomValues(bytes); } while (bytes[0] >= limit);
    return bytes[0] % size;
  };
  // Rejection sampling keeps all accepted passwords equally likely.
  for (;;) {
    const password = Array.from({ length: 20 }, () => alphabet[randomIndex(alphabet.length)]).join("");
    if (groups.every(group => [...password].some(char => group.includes(char)))) return password;
  }
}

export default function PasswordInput({ value, onChange, onSuggest, disabled = false, ...props }) {
  const [visible, setVisible] = useState(false);
  const [notice, setNotice] = useState("");
  const input = useRef(null);
  useEffect(() => { setNotice(""); }, [value]);
  function generate() {
    try { onSuggest(suggestPassword()); setNotice(""); }
    catch { setNotice("Nu am putut genera parola. Introduceți o parolă manual."); }
  }
  async function copy() {
    try {
      if (!navigator.clipboard?.writeText) throw new Error("Clipboard unavailable");
      await navigator.clipboard.writeText(value);
      setNotice("Parola a fost copiată.");
    } catch {
      setVisible(true);
      setNotice("Copierea automată nu este disponibilă. Selectați parola și apăsați Ctrl+C.");
      input.current?.focus();
      input.current?.select();
    }
  }
  return <>
    <input {...props} ref={input} className={props.className || "form-control"}
      type={visible ? "text" : "password"} value={value} onChange={onChange}
      disabled={disabled} autoComplete="new-password" spellCheck={false} />
    <div className="d-flex flex-wrap gap-2 mt-2">
      <button type="button" className="btn btn-outline-primary btn-sm" disabled={disabled} onClick={generate}>Sugerează parolă</button>
      <button type="button" className="btn btn-outline-secondary btn-sm" disabled={disabled || !value} onClick={copy}>Copiază</button>
      <button type="button" className="btn btn-outline-secondary btn-sm" disabled={disabled} aria-pressed={visible} onClick={() => setVisible(v => !v)}>{visible ? "Ascunde parola" : "Arată parola"}</button>
    </div>
    <small className="d-block text-muted mt-1">Sugestie: 20 de caractere, cu litere mari și mici, cifre și simboluri. Puteți edita sau lipi o altă parolă.</small>
    <div role="status" className="small mt-1">{notice}</div>
  </>;
}
